// extracted by mini-css-extract-plugin
export default {"backdrop":"ConfirmationModal-backdrop_nLW","modal":"ConfirmationModal-modal__i8"};